import { render } from "./Remarks.vue?vue&type=template&id=4205183b&scoped=true"
import script from "./Remarks.vue?vue&type=script&lang=js"
export * from "./Remarks.vue?vue&type=script&lang=js"

import "./Remarks.vue?vue&type=style&index=0&id=4205183b&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4205183b"]])

export default __exports__